import React, { useState } from 'react';
import { Plus } from 'lucide-react';
import { useCompanies } from '../hooks/useCompanies';
import CompanyList from '../components/companies/CompanyList';
import AddCompanyPopup from '../components/companies/AddCompanyPopup';
import SearchBar from '../components/contacts/SearchBar';

export default function Companies() {
  const { companies, loading, error, refetch } = useCompanies();
  const [showAddCompany, setShowAddCompany] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  if (loading) {
    return <div className="text-gray-400">Loading companies...</div>;
  }

  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  const filteredCompanies = companies.filter(company =>
    company.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    company.industry?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
        <h1 className="text-2xl font-bold">Companies</h1>
        <button 
          onClick={() => setShowAddCompany(true)}
          className="btn btn-primary flex items-center gap-2"
        >
          <Plus className="w-5 h-5" />
          Add Company
        </button>
      </div>

      <div className="flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex-1">
          <SearchBar 
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder="Search companies..."
          />
        </div>
      </div>

      {filteredCompanies.length === 0 ? (
        <div className="text-center text-gray-400 py-12">
          {companies.length === 0 
            ? "No companies found. Add your first company to get started."
            : "No companies match your search."}
        </div>
      ) : (
        <CompanyList companies={filteredCompanies} />
      )}

      {showAddCompany && (
        <AddCompanyPopup
          onClose={() => setShowAddCompany(false)}
          onSuccess={() => {
            refetch();
            setShowAddCompany(false);
          }}
        />
      )}
    </div>
  );
}